import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Table } from "./Table";
import useToggle from "../../hooks/useToggle";
import { IUser } from "../../models/BaseModel";

export interface IOpenForm {
    open: boolean,
    singleData: IUser
}

export const LeadProgressReport = ({ hasPermission }: { hasPermission: (pageName: string, featureName?: string) => boolean }) => {

    const [reload, reloadData] = useToggle();
    const toast = useRef<any>(null);



    return (
        <>
            
            <Table  toast={toast} reload={reload} reloadData={reloadData}></Table>
            <Toast ref={toast} />
        </>
    );
}
